export const PrimaryLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "RECORD",
                "tableName": "WMDYNEVALCHARGECONFIG",
                "label": "Record #",
                "type": "text",
                "required": false,
                "visible": true,
                "readOnly": true,
                "isLabelChanged": false,
            },
            {
                "name": "DESCRIPTION",
                "tableName": "WMDYNEVALCHARGECONFIG",
                "label": "Description",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            
            
           
        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "CHARGETYPE",
                "tableName": "WMDYNEVALCHARGECONFIG",
                "label": "Charge Type",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "RCHARGE",
                "tableName": "WMDYNEVALCHARGECONFIG",
                "label": "Charge Code",
                "type": "select",
                "required": true,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    },{
        "groupId": 3,
        "label": "",
        "fields": [
            {
                "name": "CHARGEDESCRIPTIONSOURCE",
                "tableName": "WMDYNEVALCHARGECONFIG",
                "label": "Charge Desc Src",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "STATUS",
                "tableName": "WMDYNEVALCHARGECONFIG",
                "label": "Status",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            
        ]
    },{
        "groupId": 4,
        "label": "",
        "fields": [
            {
                "name": "CHARGEDESCRIPTION",
                "tableName": "WMDYNEVALCHARGECONFIG",
                "label": "Charge Description",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "COMMENT",
                "tableName": "WMDYNEVALCHARGECONFIG",
                "label": "Comment",
                "type": "textarea",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }
];


